import React from 'react';
import { BENEFITS_TABS } from '@/constants/content';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Building, Briefcase, CheckCircle2 } from 'lucide-react';

const iconMap = {
  Building: Building,
  Briefcase: Briefcase,
};

export const BenefitsTabs = () => {
  return (
    <section
      id="beneficios"
      className="py-20 lg:py-32"
      style={{ background: 'linear-gradient(to bottom, #eff6ff 0%, #ffffff 100%)' }}
      data-testid="benefits-tabs-section"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2
            className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: 'Manrope, sans-serif' }}
            data-testid="benefits-title"
          >
            {BENEFITS_TABS.title}
          </h2>
        </div>

        {/* Tabs */}
        <Tabs defaultValue="private" className="w-full" data-testid="benefits-tabs">
          <TabsList className="grid w-full max-w-md mx-auto grid-cols-2 mb-12">
            {BENEFITS_TABS.tabs.map((tab) => {
              const Icon = iconMap[tab.icon];
              return (
                <TabsTrigger
                  key={tab.id}
                  value={tab.id}
                  className="flex items-center gap-2"
                  data-testid={`tab-trigger-${tab.id}`}
                >
                  <Icon className="w-4 h-4" />
                  {tab.label}
                </TabsTrigger>
              );
            })}
          </TabsList>

          {BENEFITS_TABS.tabs.map((tab) => {
            const Icon = iconMap[tab.icon];
            return (
              <TabsContent
                key={tab.id}
                value={tab.id}
                className="mt-0"
                data-testid={`tab-content-${tab.id}`}
              >
                <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-12 border border-gray-200">
                  <div className="flex items-start gap-4 mb-8">
                    <div className="w-14 h-14 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: '#F3E8C6' }}>
                      <Icon className="w-7 h-7" style={{ color: '#D7A22F' }} />
                    </div>
                    <div>
                      <h3
                        className="text-2xl lg:text-3xl font-bold text-gray-900 mb-2"
                        style={{ fontFamily: 'Manrope, sans-serif' }}
                        data-testid={`tab-title-${tab.id}`}
                      >
                        {tab.title}
                      </h3>
                    </div>
                  </div>

                  <ul
                    className="grid md:grid-cols-2 gap-4"
                    data-testid={`benefits-list-${tab.id}`}
                  >
                    {tab.benefits.map((benefit, index) => (
                      <li
                        key={index}
                        className="flex items-start gap-3"
                        data-testid={`benefit-item-${tab.id}-${index}`}
                      >
                        <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                        <span className="text-gray-700 leading-relaxed">
                          {benefit}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </TabsContent>
            );
          })}
        </Tabs>
      </div>
    </section>
  );
};